<template>
  <aside class="w-64 bg-gray-900 text-white min-h-screen flex flex-col">
    <div class="p-6">
      <h1 class="text-2xl font-bold">Admin Panel</h1>
    </div>
    <nav class="px-4 flex-1">
      <router-link
        to="/"
        class="block px-4 py-3 rounded-lg mb-2 transition-colors"
        :class="isActive('/') ? 'bg-gray-800 text-blue-400' : 'hover:bg-gray-800'"
      >
        <span class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          Главная
        </span>
      </router-link>
      <router-link
        to="/networks"
        class="block px-4 py-3 rounded-lg mb-2 transition-colors"
        :class="isActive('/networks') ? 'bg-gray-800 text-blue-400' : 'hover:bg-gray-800'"
      >
        <span class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
          </svg>
          Сети
        </span>
      </router-link>
      <router-link
        to="/tokens"
        class="block px-4 py-3 rounded-lg mb-2 transition-colors"
        :class="isActive('/tokens') ? 'bg-gray-800 text-blue-400' : 'hover:bg-gray-800'"
      >
        <span class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Токены
        </span>
      </router-link>
      <router-link
        to="/pack-credits"
        class="block px-4 py-3 rounded-lg mb-2 transition-colors"
        :class="isActive('/pack-credits') ? 'bg-gray-800 text-blue-400' : 'hover:bg-gray-800'"
      >
        <span class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Пакеты кредитов
        </span>
      </router-link>
      <router-link
        to="/users"
        class="block px-4 py-3 rounded-lg mb-2 transition-colors"
        :class="isActive('/users') ? 'bg-gray-800 text-blue-400' : 'hover:bg-gray-800'"
      >
        <span class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          Пользователи
        </span>
      </router-link>
      <router-link
        to="/alerts"
        class="block px-4 py-3 rounded-lg mb-2 transition-colors"
        :class="isActive('/alerts') ? 'bg-gray-800 text-blue-400' : 'hover:bg-gray-800'"
      >
        <span class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          Alerts
        </span>
      </router-link>
      <router-link
        to="/transactions"
        class="block px-4 py-3 rounded-lg mb-2 transition-colors"
        :class="isActive('/transactions') ? 'bg-gray-800 text-blue-400' : 'hover:bg-gray-800'"
      >
        <span class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
          </svg>
          Транзакции
        </span>
      </router-link>
      <router-link
        to="/invoices"
        class="block px-4 py-3 rounded-lg mb-2 transition-colors"
        :class="isActive('/invoices') ? 'bg-gray-800 text-blue-400' : 'hover:bg-gray-800'"
      >
        <span class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Инвойсы
        </span>
      </router-link>
    </nav>
    <div class="p-4 border-t border-gray-800">
      <button
        @click="handleLogout"
        class="w-full flex items-center px-4 py-3 rounded-lg hover:bg-gray-800 transition-colors text-red-400"
      >
        <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        Выйти
      </button>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const route = useRoute();
const authStore = useAuthStore();

const isActive = (path: string): boolean => {
  return route.path === path || route.path.startsWith(path + '/');
};

const handleLogout = () => {
  authStore.logout();
};
</script>

